import r from "styled-components";
import o from "../../../utils/colors.js";
const i = r.div`
  width: 100%;
  box-sizing: border-box;
  background-color: ${o.darkGrey};
  color: ${o.white};
  display: flex;
`;
export {
  i as MenuContent
};
